import { GetAddress } from '@/services/apis'
import request from '@/services/request'

export function getAddress(location: string): Promise<any> {
	const params = {
		coordtype: 'wgs84',
		locations: [
			{
				longitude: Number(location.split(',')[1]),
				latitude: Number(location.split(',')[0])
			}
		],
		getCache: true
	}

	return request.post(GetAddress, params, { timeout: 3000 }).catch(err => {
		console.log('请求超时', err)
	})
}

export function getBatchTripAddress(locations: string[]): Promise<any[]> {
	const locationsArr = locations.map(lct => {
		return {
			longitude: Number(lct.split(',')[1]),
			latitude: Number(lct.split(',')[0])
		}
	})

	const params = {
		coordtype: 'wgs84',
		locations: locationsArr,
		getCache: true
	}

	return request
		.post(GetAddress, params, { timeout: 3000 })
		.then((res: any) => {
			return res
		})
		.catch(err => {
			console.log('请求超时', err)
		})
}
